import {useMemo} from 'react'
import {Empty, Space, Table, Typography} from 'antd'
import {DeleteOutlined, EditOutlined} from '@ant-design/icons'
import EllipsisTooltip from '../../common/EllipsisTooltip'
import RecordsCount from '../../common/RecordsCount'
import TableActions from '../../common/TableActions'
import {useIntl} from 'react-intl'
import {humanizeBool} from '../../../utils/common'

const ModuleTable = ({
  dataSource,
  pagination = false,
  getModulesData = null,
  onEdit = null,
  onDelete = null,
}) => {
  const intl = useIntl()

  const columns = useMemo(
    () => [
      {
        title: (
          <EllipsisTooltip className="ellipsis">
            {intl.formatMessage({ id: 'modules.acronym' })}
          </EllipsisTooltip>
        ),
        dataIndex: 'acronym',
        width: '25%',
        sorter: (a, b) => (a.acronym || '').localeCompare(b.acronym || ''),
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {text || '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: (
          <EllipsisTooltip className="ellipsis">
            {intl.formatMessage({ id: 'modules.moduleId' })}
          </EllipsisTooltip>
        ),
        dataIndex: 'module_id',
        width: '20%',
        sorter: (a, b) => (a.module_id || '').localeCompare(b.module_id || ''),
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {text || '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: (
          <EllipsisTooltip className="ellipsis">
            {intl.formatMessage({ id: 'modules.connectorId' })}
          </EllipsisTooltip>
        ),
        dataIndex: 'connector_names',
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {text || '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: (
          <EllipsisTooltip className="ellipsis">
            {intl.formatMessage({ id: 'modules.hasDtc' })}
          </EllipsisTooltip>
        ),
        dataIndex: 'is_dtc_exists',
        width: 100,
        align: 'center',
        render: (value) => (
          <span>{humanizeBool(value)}</span>
        ),
      },
      {
        title: (
          <EllipsisTooltip className="ellipsis">
            {intl.formatMessage({ id: 'modules.action' })}
          </EllipsisTooltip>
        ),
        align: 'right',
        width: 136,
        render: (_, record) => (
          <TableActions
            actions={[
              { key: 'edit', label: intl.formatMessage({ id: 'forms.edit' }), icon: <EditOutlined />, onClick: () => onEdit(record) },
              { key: 'delete', label: intl.formatMessage({ id: 'forms.delete' }), icon: <DeleteOutlined />, danger: true, onClick: () => onDelete(record) },
            ]}
          />
        ),
      },
    ],
    [dataSource, pagination]
  )

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{ width: '100%', verticalAlign: 'top' }}
    >
      <Table
        rowKey={(record) => `module-${record.acronym}`}
        columns={columns}
        dataSource={dataSource}
        showSorterTooltip={false}
        tableLayout='fixed'
        scroll={{
          x: dataSource.length > 0 ? 710 : undefined
        }}
        pagination={
          pagination
            ? {
                current: pagination?.currentPage,
                total: pagination?.totalCount,
                pageSize: 10,
                showSizeChanger: false,
                hideOnSinglePage: true,
                showTotal: (total) => <RecordsCount count={total} />,
                onChange: (page) => {
                  const offset = (page - 1) * 10
                  const url = pagination?.nextPageLink
                    ? new URL(pagination?.nextPageLink)
                    : new URL(pagination?.prevPageLink)
                  url.searchParams.set('offset', offset)
                  getModulesData(url.toString())
                },
              }
            : false
        }
        locale={{
          emptyText: (
            <div style={{ padding: '40px' }}>
              <Empty description={<RecordsCount count={0} />} />
            </div>
          ),
        }}
      />
      {pagination && pagination?.totalPages <= 1 && pagination?.totalCount > 0 && (
        <Typography.Text>
          <RecordsCount count={pagination?.totalCount} />
        </Typography.Text>
      )}
    </Space>
  )
}

export default ModuleTable
